<template>
  <div class="rel-window">
        <div class="relevant-elements-background" @click="closeRelWindow()"></div>
        <div class="relevant-elements-body" :class="{lgAndUp: $vuetify.breakpoint.lgAndUp, mobile: $vuetify.breakpoint.xs}">
            <div class="d-block mx-5 mt-7">
                <div class="flex-center-between">
                    <div class="roboto-normal-18 clr-black-38">Добавить связь:</div>
                </div>
                <v-text-field
                    class="mt-5"
                    :append-icon="'mdi-magnify'"
                    solo
                    clear-icon="mdi-close-circle"
                    clearable
                    label="Введите текст..."
                    type="text"
                    v-model="searchElements"
                    @input="inputSearch"
                    @click:clear="closeShowedSearchElements"
                ></v-text-field>
                <div class="search-related" v-if="searchElements && searchElements.length > 2 && showedSearchElements" v-click-outside="closeShowedSearchElements">
                    <div class="roboto-normal-16 clr-black-38" v-if="foundedTasks.length">Подразделы:</div>
                    <div v-for="task in foundedTasks" :key="task._id">
                        <div class="mt-3 pt-3 pl-3 roboto-normal-14 clr-black-38 relevant-task" @click="addRelatedTaskForElements(task)">{{task.name}}</div>
                    </div>
                    <div class="roboto-normal-16 clr-black-38 mt-3" v-if="foundedSubs.length">Заметки:</div>
                    <div v-for="sub in foundedSubs" :key="sub._id">
                        <div class="mt-3 pt-3 pl-3 roboto-normal-14 clr-black-38 relevant-sub" @click="addRelatedSubForElements(sub)">{{sub.name}}</div>
                    </div>
                    <small v-show="!(foundedTasks.length || foundedSubs.length)">Не найдено ...</small>
                </div>
                <div v-else>
                    <div id="themes-drag" class="ml-n2 flex-center relevant-theme-scroll" @wheel.prevent="toHorizontalScroll($event)">
                        <div v-for="theme in allThemes" :key="theme._id">
                            <div class="theme ml-2" @click="chooseTheme(theme)" :class="{active: allThemes[0]._id == theme._id && !currentTheme || currentTheme && currentTheme._id == theme._id}">
                                <div class="pt-3 pl-3 roboto-normal-14 clr-black-38">{{theme.name}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="task-sub-header">
                        <div class="roboto-normal-16 clr-black-38 mt-11 ml-n4" v-if="mainTasks && mainTasks.length">С подразделами:</div>
                        <div class="roboto-normal-16 clr-black-38 mt-11 ml-12" v-if="mainSubs && mainSubs.length">С заметками:</div>
                    </div>
                    <div class="relevant-task-sub" v-if="mainTasks.length">
                        <div class="relevant-task-scroll">
                            <div v-for="task in mainTasks" :key="task._id">
                                <div class="d-flex">
                                    <div>
                                        <div class="mt-3 pt-3 pl-3 roboto-normal-14 clr-black-38 relevant-task text-capitalize" @click="chooseTask(task)" :class="{active: mainTasks[0]._id == task._id && !currentTask || currentTask && currentTask._id == task._id}">{{task.name}}</div>
                                        <div class="text-center roboto-normal-12 clr-black-38" v-if="addElementsInTask ? current_task.relatedTasks.find(el => el == task._id) : picked_sub.relatedTasks.find(el => el == task._id)">Cвязь с подразделом</div>
                                        <div class="text-center roboto-normal-12 clr-black-38 mt-n2" v-if="addElementsInTask ? current_task.relatedTasks.find(el => el == task._id) : picked_sub.relatedTasks.find(el => el == task._id)">добавлена!</div>
                                    </div>
                                    <img class="mt-5 ml-2 pointer" height="33.91px" @click="addRelatedTaskForElements(task)" src="@/assets/images/components/button-add-blue.png">
                                </div>
                            </div>
                        </div>
                        <div class="relevant-sub-scroll ml-2" v-if="mainSubs.length">
                            <div v-for="sub in mainSubs" :key="sub._id">
                                <div class="mt-3 pt-3 pl-3 roboto-normal-14 clr-black-38 relevant-sub text-capitalize" @click="addRelatedSubForElements(sub)">{{sub.name}}</div>
                                <div class="text-center roboto-normal-12 clr-black-38" v-if="addElementsInTask ? current_task.relatedSubs.find(el => el == sub._id) : picked_sub.relatedSubs.find(el => el == sub._id)">Cвязь с заметкой</div>
                                <div class="text-center roboto-normal-12 clr-black-38 mt-n2" v-if="addElementsInTask ? current_task.relatedSubs.find(el => el == sub._id) : picked_sub.relatedSubs.find(el => el == sub._id)">добавлена!</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center roboto-normal-18 clr-blue my-7" @click="completeRelElements()">Готово</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ClickOutside from 'vue-click-outside'
export default {
    name: 'RelatedWindow',
    data() {
        return {
            searchElements: '',
            showedSearchElements: true,
            currentTheme: null,
            currentTask: null,
            searchElements: '',
            showedSearchElements: true,
        }
    },
    props: ['element', 'addElementsInTask'],
    computed:{
        ...mapGetters(["themes", "current" , "current_task", "picked_sub"]),
        allThemes() {
            return this.themes
        },
        allTasks() {
            return this.themes.map(theme => {
                return theme.tasks
            }).flat() 
        },
        foundedTasks() {
            return this.searchElements.length > 2 ? 
            this.allTasks.filter(task => task.name.toLowerCase().includes(this.searchElements.toLocaleLowerCase())) : []
        },
        allSubs() {
            return this.themes.map(theme => {
                return theme.tasks.map(task => {
                    return task.subs
                }).flat()
            }).flat()
        },
        foundedSubs() {
            return this.searchElements.length > 2 ? 
            this.allSubs.filter(sub => sub.name.toLowerCase().includes(this.searchElements.toLocaleLowerCase())) : []
        },
        mainTasks() {
            return this.currentTheme ? this.currentTheme.tasks : this.allThemes[0].tasks
        },
        mainSubs() {
            return this.currentTask ? this.currentTask.subs : []
        }
    },
    methods:{
        ...mapActions(['addRelatedTaskInTask', 'addRelatedSubInTask', 'addRelatedTaskInSub', 'addRelatedSubInSub']),
        async addRelatedTaskForElements(task) {
            const theme = this.themes.find(theme => {
                return theme.tasks.find(item => item._id == task._id)
            })
            if(this.addElementsInTask) {
                await this.addRelatedTaskInTask({_id: this.current._id, task: this.element, related_task_id: task._id})
                await this.addRelatedTaskInTask({_id: theme._id, task, related_task_id: this.element._id})
            } else {
                await this.addRelatedTaskInSub({_id: this.current._id, task: this.current_task, sub: this.element, related_task_id: task._id})
                await this.addRelatedSubInTask({_id: theme._id, task, related_sub_id: this.element._id})
            }
        },
        async addRelatedSubForElements(sub) {
            const theme = this.themes.find(theme => {
                return theme.tasks.find(task => {
                    return task.subs.find(item => item._id == sub._id)
                })
            })
            const task = theme.tasks.find(task => {
                return task.subs.find(item => item._id == sub._id)
            })
            if(this.addElementsInTask) {
                await this.addRelatedSubInTask({_id: this.current._id, task: this.element, related_sub_id: sub._id})
                await this.addRelatedTaskInSub({_id: theme._id, task, sub, related_task_id: this.element._id})
            } else {
                await this.addRelatedSubInSub({_id: this.current._id, task: this.current_task, sub: this.element, related_sub_id: sub._id})
                await this.addRelatedSubInSub({_id: theme._id, task, sub, related_sub_id: this.element._id})
            }
        },
        inputSearch() {
            this.showedSearchElements = true
        },
        closeShowedSearchElements() {
            this.showedSearchElements = false
        },
        toHorizontalScroll(e) {
            e = window.event || e
            let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)))
            document.getElementById('themes-drag').scrollLeft -= (delta*50)
        },
        chooseTheme(theme) {
            this.currentTheme = theme
            this.currentTask = null
        },
        completeRelElements() {
            this.$emit('toCloseRelWindow')
            this.searchElements = ""
        },
        chooseTask(task) {
            this.currentTask = task
        },
        closeRelWindow() {
            this.$emit('toCloseRelWindow')
            this.searchElements = ""
        }
    },
    directives: {
        ClickOutside
    }
}
</script>

<style lang="scss" scoped>
.rel-window {
    .relevant-elements-body {
        position:fixed;
        margin:auto;
        top: 145px;
        right: 0;
        left: 0;
        width: 340px;
        height: auto;
        max-width: 100vw;
        background:#F2F2F2;
        mix-blend-mode: normal;
        border-radius: 16px;
        z-index: 112;
        &.lgAndUp {
            width: 540px;
        }
        &.mobile {
            top: 20px;
        }
        .search-related {
            display: flex;
            flex-direction: column;
            align-items: center;
            max-height:420px;
            overflow-x: hidden;
            overflow-y: auto;
            -ms-overflow-style: -ms-autohiding-scrollbar;
            -webkit-overflow-scrolling: touch;
            white-space: nowrap;
            &::-webkit-scrollbar {
                display: none;
            }
        }
        .relevant-task-sub, .task-sub-header {
            display: flex;
            align-items: center;
            justify-content: center;
            .relevant-task {
                width: 125px;
                min-height: 46px;
                height:auto;
                background: #18A0FB;
                border-radius: 6px;
                &:hover {
                    background: #0E85D5;
                }
            }
            .relevant-sub {
                width: 125px;
                min-height: 46px;
                height:auto;
                background: #DEFFEF;
                border-radius: 6px;
                &:hover {
                    background: #72FFBC;
                }
            }
        }
        .theme {
            width: 117px;
            height: 72px;
            background: #EEF8FF;
            border-radius: 6px;
            &.active {
                background: #BEE5FF;
            }
        }
        .relevant-theme-scroll {
            overflow-x: auto;
            overflow-y: hidden;
            -ms-overflow-style: -ms-autohiding-scrollbar;
            -webkit-overflow-scrolling: touch;
            white-space: nowrap;
            &::-webkit-scrollbar {
                display: none;
            }
        }
        .relevant-task-scroll, .relevant-sub-scroll {
            height:150px;
            // width: 255px;
            overflow-x: hidden;
            overflow-y: auto;
            -ms-overflow-style: -ms-autohiding-scrollbar;
            -webkit-overflow-scrolling: touch;
            white-space: nowrap;
            &::-webkit-scrollbar {
                display: none;
            }
            .relevant-task {
                width: 125px;
                min-height: 46px;
                height:auto;
                background: #18A0FB;
                border-radius: 6px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                &:hover {
                    background: #0E85D5;
                }
                &.active {
                    background: #0E85D5;
                }
            }
            .relevant-sub {
                width: 125px;
                min-height: 46px;
                height:auto;
                background: #DEFFEF;
                border-radius: 6px;
                white-space:nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                &:hover {
                    background: #72FFBC;
                }
            }
        }
    }
    .relevant-elements-background {
        min-height: 100% !important;
        min-width: 600px !important;
        width:100% !important;
        height: auto !important;
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        background: rgba(87, 87, 87, 0.5) !important;
        z-index: 111 !important;
    }
}
</style>